import $ from 'jquery';

export default class Form {
	init() {
		$('form').each(function () {
			if ($(this).find('fieldset').length) {
				$(this).find('.submit button').addClass('two-cols');
			}
		});
	}
}
